import { usePage } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import type { SharedProps } from '@/frontend/types/inertia'
import { forgeNavigationPath, forgeProjectId } from '@/frontend/layouts/worker-first/forgeNavigation'

export function AgentRoleBadge({ role, projectName }: { role: string | null | undefined; projectName?: string }) {
  if (!role?.trim()) return null
  return <span title={projectName ? `${role} · ${projectName}` : role}
    className="max-w-28 shrink truncate rounded border border-border/60 bg-muted/40 px-1.5 py-0.5 text-[10px] font-normal leading-none text-muted-foreground">{role}</span>
}

/** The server's current project assignments govern labels. A null explicit
 * project means general chat, not the last/default project. No local cache. */
export default function ProjectAgentName({ workerId, name, projectId, nameClassName, className }: {
  workerId: string; name: string; projectId?: string | null; nameClassName?: string; className?: string
}) {
  const { props, url } = usePage<SharedProps>()
  const currentProjectId = projectId === undefined
    ? forgeProjectId(url, forgeNavigationPath(url) ? props.forgeAccess?.default_project_id : null)
    : projectId
  const project = props.forgeAccess?.projects.find(row => row.id === currentProjectId)
  return <span className={cn('flex min-w-0 items-center gap-1.5', className)}>
    <span className={cn('min-w-0 truncate', nameClassName)}>{name}</span>
    <AgentRoleBadge role={project?.agent_roles?.[workerId]} projectName={project?.name} />
  </span>
}
